import './close-button.scss';

import { SyntheticEvent } from 'react';

import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

import { cn } from '../../utils/helpers';

export interface CloseButtonProps extends React.ComponentPropsWithRef<'button'> {
  className?: string;
  invert?: boolean;
  onClose?: (e: SyntheticEvent) => void;
}
export const CloseButton: React.FC<CloseButtonProps> = ({
  className,
  invert,
  ...props
}) => {
  return (
    <button
      className={cn('CloseBtn', {
        [`${className}`]: !!className,
        'CloseBtn--invert': invert,
      })}
      type="button"
      {...props}
    >
      <ArkIcon iconName="x-close" aria-hidden />
    </button>
  );
};
